import {useEffect, useState} from "react";
import {getAllBatches} from "../../api/Api";
import {AutoComplete, Card, Row} from "antd";

export const BatchSelectWidget = ({selectedBatch, onSelect, disabled=false, refresh, onApiFail, props}) => {
    const [batches, setBatches] = useState([]);
    const [options, setOptions] = useState([]);

    const [select, setSelect] = useState(true);
    const [value, setValue] = useState(undefined);

    useEffect(() => {
        getAllBatches().then(data => {
            const b = data.map(val => {
                return {
                    key: val.id,
                    ...val,
                }
            })
            setBatches(b);
        }).catch(e => {
            if (e.status === 401) {
                if (onApiFail) {
                    onApiFail();
                }
            }
        });
    }, [onApiFail, refresh]);

    const onChange = (data) => {
        setValue(data);
    }

    const onSearch = (text) => {
        const newOptions = batches.filter(batch => {
            const ltext = text.toLowerCase();
            return batch.name.toLowerCase().includes(ltext);
        }).map(val => {
            return {
                value: `${val.name}`,
                batch: val
            }
        });
        setOptions(newOptions)
    }

    const selectBatch = (val, option) => {
        if (onSelect) {
            onSelect(option.batch);
        }
        setSelect(false);
    }

    const autoCompleteStyle = {
        width: 200
    }

    const clickBatch = () => {
        setSelect(true && !disabled);
    }

    const autocomp = <Card><AutoComplete options={options} style={autoCompleteStyle} value={value} placeholder={'Batch'} onChange={onChange} onSearch={onSearch} onSelect={selectBatch} /></Card>

    const card = (selectedBatch) ? <Card style={{width: 300}}>
            <div onClick={clickBatch}>
                <Row><b>Batch</b></Row>
                <Row>{selectedBatch.name}</Row>
            </div>
        </Card>
    : <Card><div /></Card>

    return (select || (selectedBatch === null) || (selectedBatch === undefined)) ? autocomp : card;
}